
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"15","fill":"none","viewBox":"0 0 16 10"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M5.53029.219727c.14647.1465.21972.337906.21972.530281 0 .192375-.07325.383782-.21972.530282L2.56057 4.25001H15.25c.4141 0 .75.33594.75.75s-.3359.75-.75.75H2.56057l2.96972 2.96972c.29297.29297.29297.76759 0 1.06056-.29297.29301-.76759.29301-1.06056 0l-4.250003-4.25c-.2929692-.29297-.2929692-.76759 0-1.06056L4.46973.219727c.29297-.2929692.76759-.2929692 1.06056 0z"}})])
          )
        }
      }
    